import { createReducer } from '@reduxjs/toolkit'
import { IAltenarState } from '../types'
import * as actions from '../actions'

const initialState: IAltenarState['data'] = {
  token: null,
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getSportToken.success, (state, action) => {
      state.token = action.payload
    })
    .addCase(actions.clearSportToken, state => {
      state.token = null
    })
})
